import React, { useState, useEffect } from 'react';
import Picture from 'Shared/Picture';
import BottonPushes from 'Shared/BottonPushes';
import Breadcrumbs from 'Header/Breadcrumbs';
import animateScrollTo from "animated-scroll-to";
import BuyNowProductPopUp from 'Shared/BuyNowProductPopUp';
import BuyUSPopUp from 'Shared/BuyUSPopUp';
import PopupNioxin from 'Shared/PopupNioxin';
import CollectionsSlider from "Collection/CollectionsSlider";
import ArticleBox from 'Articles/ArticleBox';
import shortid from 'shortid';
import PlayerYoutube from 'Shared/PlayerYoutube';
import Teaser from 'Shared/Teaser';


const CollectionPage = (props) => {
    const {
        Slider,
        breadcrumbs,
        Products,
        Collections,
        BottomTiles,
        salonCountries,
        AllProductsTitle,
        FooterDescriptionTitle,
        FooterDescription,
        YoutubeUrl,
    } = props;
    const mobileBreakpoint = 768;
    const tabletBreakpoint = 1025;
    const [isMobile, setIsMobile] = useState(window.innerWidth < mobileBreakpoint);
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= tabletBreakpoint);
    const [productPopupVisible, setProductPopupVisible] = useState(false);
    const [nioxinPopupVisible, setNioxinPopupVisible] = useState(false);

    useEffect(() => {
        window.addEventListener('resize', checkWindowWidth);
    }, []);
    const checkWindowWidth = () => {
        setIsMobile(window.innerWidth < mobileBreakpoint);
        setIsDesktop(window.innerWidth >= tabletBreakpoint);
    }

    const lang = document.getElementById("divlang").getAttribute("data-id");

    const scrollToCollection = (e, id) => {
        e.preventDefault();
        const options = {
            speed: 1000,
            verticalOffset: isDesktop ? 0 : -90
        }
        animateScrollTo(document.getElementById(id), options);
    }
    const showPopUp = (event, type, id) => {
        event.preventDefault();
        if (type === "product") {
            setProductPopupVisible(id);
        } else if (type === "nioxin") {
            setNioxinPopupVisible(id);
        }
        checkKey();
    }
    const hidePopUp = (event, type) => {
        event.preventDefault();
        if (type === "product") {
            setProductPopupVisible(false);
        } else if (type === "nioxin") {
            setNioxinPopupVisible(false);
        }
    }
    const checkKey = () => {
        document.addEventListener("keyup", function (e) {
            if (e.keyCode == 27) {
                setProductPopupVisible(false);
                setNioxinPopupVisible(false);
                document.removeEventListener("keyup", null)
            }
        })
    }

    const renderProductList = (Products) => {
        return (
            <ul className="products">
                {Products.map((product) => (
                    <li className="product" key={product.Id}>
                        <a className="product-link" href={product.ProductsUrl.Value}>
                            <Picture
                                src={[
                                    {
                                        Url: product.DetailsImage.Value + "--resize,220,220",
                                        WebpUrl: product.DetailsImage.Value + "--resize,220,220--returnTypeFile,webp"
                                    },
                                    {
                                        Url: product.DetailsImage.Value + "--resize,275,275",
                                        WebpUrl: product.DetailsImage.Value + "--resize,275,275--returnTypeFile,webp"
                                    },
                                    {
                                        Url: product.DetailsImage.Value + "--resize,150,150",
                                        WebpUrl: product.DetailsImage.Value + "--resize,150,150--returnTypeFile,webp"
                                    }
                                ]}
                                alt={product.DetailsImageAlt.Value}
                            />
                            <div>
                                <h2 dangerouslySetInnerHTML={{ "__html": product.ProductTitleForProductsList.Value ? product.ProductTitleForProductsList.Value : product.Title.Value }} />
                                <div className="bv-rating" data-bv-show="inline_rating" data-bv-product-id={product.Id} />
                            </div>
                        </a>
                        {product.ProductPopup.length > 0 ? (
                            <a href="#" onClick={(event) => showPopUp(event, "product", product.Id)} className="buy-now-button">
                                <span>{product.ProductPopup[0].BuyNowButtonText && product.ProductPopup[0].BuyNowButtonText.Value !== "" ? product.ProductPopup[0].BuyNowButtonText.Value : "BUY NOW"}</span>
                            </a>
                        ) : product.BuyNowPopup.length > 0 ? (
                            <a href="#" onClick={(event) => showPopUp(event, "nioxin", product.Id)} className="buy-now-button">
                                <span>{product.BuyNowPopup[0].BuyNowText.Value}</span>
                            </a>
                        ) : product.BuyNowButtonText.Value !== "" ? (
                            <a href={product.BuyNowButtonUrl.Value} className="buy-now-button" data-test="buynow-button" target='_blank'>
                                <span>{product.BuyNowButtonText.Value}</span>
                            </a>
                        ) : null}
                        {(productPopupVisible === product.Id) && (
                            lang === "en-US" ? (
                                <BuyUSPopUp
                                    productHidePopUp={hidePopUp}
                                    productPopup={productPopupVisible}
                                    Product={product.ProductPopup[0]}
                                />
                            ) : (
                                    <BuyNowProductPopUp
                                        productHidePopUp={hidePopUp}
                                        productPopup={productPopupVisible}
                                        Product={product.ProductPopup[0]}
                                        SocialShareCopyTextFacbook={product.SocialShareCopyTextFacbook}
                                        SocialShareCopyTextPinttrest={product.SocialShareCopyTextPinttrest}
                                        SocialShareCopyTextTwitter={product.SocialShareCopyTextTwitter}
                                        FacebookLink={product.FacebookLink}
                                        PinterestLink={product.PinterestLink}
                                        isDesktop={isDesktop}
                                    />
                                )
                        )}
                        {(nioxinPopupVisible === product.Id) && (
                            <PopupNioxin
                                hidePopUp={hidePopUp}
                                popup={nioxinPopupVisible}
                                pushesPopup={product.BuyNowPopup}
                            />
                        )}
                    </li>
                ))}
            </ul>
        );
    }
    const videoSectionClass = YoutubeUrl && YoutubeUrl.Value !== "" ? "active" : "disabled";
    return (
        <div>
            {Slider.length > 0 && (
                <div className="main-visual">
                    <Picture
                        src={Slider[0].SliderImage.Value}
                        alt={Slider[0].SliderImageAlt.Value}
                        mobileHeight={307}
                    />
                    {Slider[0].Url.Value !== "" && (
                        <a className="visual-url" href={Slider[0].Url.Value}></a>
                    )}
                    {Slider[0].Title.Value !== "" && (
                        <div className="visual-text-wrapper">
                            <div className="visual-text">
                                <div className="visual-text-box">
                                    <h1 dangerouslySetInnerHTML={{ "__html": Slider[0].Title.Value }} />
                                    {Slider[0].Subtitle.Value !== "" && (
                                        <div className="description" dangerouslySetInnerHTML={{ "__html": Slider[0].Subtitle.Value }} />
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
            <div className="main">
                <Breadcrumbs breadcrumbProps={breadcrumbs.Breadcrumb} />
                <div className={`video-section ${videoSectionClass}`}>
                    {YoutubeUrl && YoutubeUrl.Value !== "" ? (
                        <PlayerYoutube
                            youtubeUrl={YoutubeUrl.Value}
                            teaserId={props.Id}
                            teaser={props}
                        // teaserClass={"teaserClass"}
                        />
                    ) : null}
                </div>
                {Collections !== undefined && Collections.length > 0 ? (
                    <React.Fragment>
                        {isMobile ? (
                            <CollectionsSlider
                                collections={Collections}
                                scrollToCollection={scrollToCollection}
                                AllProductsTitle={AllProductsTitle}
                            />
                        ) : null}
                        {Collections.map((collection) => (
                            <React.Fragment key={collection.Id}>
                                <h2 id={collection.Id} className="collection-title">
                                    {collection.MoreDetailsButtonUrl.Value !== "" ? (
                                        <a href={collection.MoreDetailsButtonUrl.Value}>{collection.Title.Value}</a>
                                    ) : (
                                            collection.Title.Value
                                        )}
                                </h2>
                                {renderProductList(collection.Products)}
                            </React.Fragment>
                        ))}
                    </React.Fragment>
                ) : (
                        renderProductList(Products)
                    )}
                <div className="main informational-boxes">
                    {props.ArticleBoxs ? props.ArticleBoxs.map((box) => {
                        return <ArticleBox key={shortid.generate()} box={box} />
                    }) : null}
                </div>
                <div className="footer-text">
                    {FooterDescriptionTitle && FooterDescriptionTitle.Value !== "" ? <h3 className="footer-text-title">{FooterDescriptionTitle.Value}</h3> : null}
                    {FooterDescription && FooterDescription.Value !== "" ? <p className="footer-text-desc">{FooterDescription.Value}</p> : null}
                </div>
                {props.Teasers && (
                    <Teaser teaser={props.Teasers} teaserClass={"teaser-collection"} />
                )}
                <BottonPushes
                    salonFinder={props}
                    bottonPushes={BottomTiles}
                    salonCountries={salonCountries}
                />
            </div>
        </div>
    );
}
export default CollectionPage;
